import script from "./esNameForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./esNameForm.vue?vue&type=script&lang=ts&setup=true"

import "./esNameForm.vue?vue&type=style&index=0&id=222fe785&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222fe785"]])

export default __exports__